// extracted by mini-css-extract-plugin
module.exports = {"columnswrapper":"DataInfo_columnswrapper__W8jGD","columns":"DataInfo_columns__f5Wk4"};